// extracted by css-extract-rspack-plugin
export default {"handle":"handle-hMfCU8","chevron":"chevron-umpT_D"};